import { useTheme } from "@rentiohq/web-shared-next/dist/themes";

export const DocumentInfoStyles = () => {
  return {
    content: {
      docPreview: {
        width: "100%",
        height: "160px",
        display: "flex",
        justifyContent: "center",
        cursor: "pointer",
        borderRadius: "4px",
        padding: "6px",
        backgroundColor: "rgba(0, 0, 0, 0.04)",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
      },
      imgPreview: {
        height: "100%",
      },
      memberRoles: {
        textWrap: "wrap",
        fontSize: "12px",
      },
    },
  };
};

export const DocumentMetaStyles = () => {
  const theme = useTheme();

  return {
    content: {
      propertyTitle: {
        cursor: "pointer",
        color: theme.palette.success.main,
      },
    },
  };
};
